export default {
  SET_RULES: 'SET_RULES',
  SET_PAYTABLE: 'SET_PAYTABLE',
  UPDATE_FUTURE: 'UPDATE_FUTURE',
  SET_SINGLE_BET_INPUT_VALUE: 'SET_SINGLE_BET_INPUT_VALUE',
};
